import { useState, useEffect, useRef } from "react";

const API = "";
const ADMIN_PASS = "admin123";

const GOOGLE_FONTS = `@import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,600;1,9..144,300&family=DM+Sans:wght@300;400;500&display=swap');`;

const style = `
  ${GOOGLE_FONTS}
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'DM Sans', sans-serif; background: #FFF9F5; color: #2D2416; }
  :root {
    --cream: #FFF9F5; --sand: #F2E8DC; --terracotta: #C9622A;
    --terra-light: #E8855A; --sage: #6B8F71; --sage-light: #E8F0E9;
    --sky: #7BAAC5; --sky-light: #E3EFF5; --warm: #2D2416;
    --muted: #7A6856; --border: rgba(45,36,22,0.12);
    --radius: 16px; --radius-sm: 8px;
  }
  h1, h2, h3 { font-family: 'Fraunces', serif; font-weight: 300; }
`;

function Logo({ url, size = 36 }) {
  if (url) return <img src={url.startsWith("http") ? url : `${API}${url}`} alt="Logo" style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />;
  return <div style={{ width: size, height: size, borderRadius: "50%", background: "var(--terracotta)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: Math.round(size * 0.5), flexShrink: 0 }}>🍎</div>;
}

function imgUrl(url) {
  if (!url) return null;
  return url.startsWith("http") ? url : `${API}${url}`;
}

function useAPI() {
  const headers = (auth = false) => auth ? { "x-admin-pass": ADMIN_PASS } : {};
  const get = (path) => fetch(`${API}${path}`, { headers: headers(true) }).then(r => r.json());
  const post = (path, body, isForm = false) =>
    fetch(`${API}${path}`, {
      method: "POST",
      headers: isForm ? { "x-admin-pass": ADMIN_PASS } : { "x-admin-pass": ADMIN_PASS, "Content-Type": "application/json" },
      body: isForm ? body : JSON.stringify(body)
    }).then(r => r.json());
  const put = (path, body, isForm = false) =>
    fetch(`${API}${path}`, {
      method: "PUT",
      headers: isForm ? { "x-admin-pass": ADMIN_PASS } : { "x-admin-pass": ADMIN_PASS, "Content-Type": "application/json" },
      body: isForm ? body : JSON.stringify(body)
    }).then(r => r.json());
  const del = (path) => fetch(`${API}${path}`, { method: "DELETE", headers: headers(true) }).then(r => r.json());
  const patch = (path) => fetch(`${API}${path}`, { method: "PATCH", headers: headers(true) }).then(r => r.json());
  return { get, post, put, del, patch };
}

export default function App() {
  const [page, setPage] = useState("accueil");
  const [adminAuth, setAdminAuth] = useState(false);
  const [loginPass, setLoginPass] = useState("");
  const [loginErr, setLoginErr] = useState(false);
  const [toast, setToast] = useState(null);
  const [actu, setActu] = useState(null);
  const [structure, setStructure] = useState(null);
  const [equipe, setEquipe] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [actualites, setActualites] = useState([]);
  const [loading, setLoading] = useState(true);
  const api = useAPI();

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 2500); };

  const loadAll = async () => {
    setLoading(true);
    try {
      const [s, e, d, a] = await Promise.all([
        api.get("/api/structure"), api.get("/api/equipe"),
        api.get("/api/documents"), api.get("/api/actualites"),
      ]);
      setStructure(s); setEquipe(e); setDocuments(d); setActualites(a);
    } catch { showToast("Erreur de connexion à l'API"); }
    setLoading(false);
  };

  useEffect(() => {
    if (window.location.hash === "#admin-3pommes") {
      setPage("login");
    }
    loadAll();
  }, []);

  const handleLogin = () => {
    if (loginPass === ADMIN_PASS) { setAdminAuth(true); setLoginErr(false); setLoginPass(""); showToast("Connecté !"); nav("admin"); }
    else setLoginErr(true);
  };
  const handleLogout = () => { setAdminAuth(false); nav("accueil"); };
  const nav = (p) => { setPage(p); setActu(null); };
  const actuPubliees = actualites.filter(a => a.publie);

  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--cream)" }}>
      <style>{style}</style>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🍎</div>
        <p style={{ color: "var(--muted)" }}>Chargement…</p>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: "var(--cream)" }}>
      <style>{style}</style>
      {toast && <div style={{ position: "fixed", bottom: 24, right: 24, background: "#2D2416", color: "#FFF9F5", padding: "10px 18px", borderRadius: 10, fontSize: 14, zIndex: 9999 }}>✓ {toast}</div>}

      <header style={{ background: "#FFF9F5", borderBottom: "1px solid var(--border)", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 20px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 64 }}>
          <button onClick={() => nav("accueil")} style={{ background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: 10 }}>
            <Logo url={structure?.logo} size={36} />
            <span style={{ fontFamily: "'Fraunces', serif", fontSize: 20, fontWeight: 300, color: "var(--warm)" }}>{structure?.nom}</span>
          </button>
          <nav style={{ display: "flex", gap: 4, alignItems: "center" }}>
            {[["accueil","Accueil"],["presentation","La structure"],["equipe","L'équipe"],["documents","Documents"],["actualites","Actualités"],["preinscription","Préinscription"]].map(([k,l]) => (
              <button key={k} onClick={() => nav(k)} style={{ background: page===k ? "var(--sand)" : "none", border: "none", cursor: "pointer", padding: "6px 14px", borderRadius: 20, fontSize: 14, color: page===k ? "var(--terracotta)" : "var(--muted)", fontFamily: "'DM Sans', sans-serif", fontWeight: page===k ? 500 : 400 }}>{l}</button>
            ))}
            {adminAuth &&
              <button onClick={() => nav("admin")} style={{ background: "var(--terracotta)", border: "none", cursor: "pointer", padding: "6px 14px", borderRadius: 20, fontSize: 14, color: "#fff", fontFamily: "'DM Sans', sans-serif", fontWeight: 500, marginLeft: 8 }}>⚙ Admin</button>
            }
          </nav>
        </div>
      </header>

      <main>
        {page === "accueil" && <PageAccueil structure={structure} actuPubliees={actuPubliees} nav={nav} setActu={setActu} />}
        {page === "presentation" && <PagePresentation structure={structure} />}
        {page === "equipe" && <PageEquipe equipe={equipe} />}
        {page === "documents" && <PageDocuments documents={documents} />}
        {page === "actualites" && <PageActualites actuPubliees={actuPubliees} actu={actu} setActu={setActu} />}
        {page === "preinscription" && <PagePreinscription api={api} showToast={showToast} />}
        {page === "login" && <PageLogin loginPass={loginPass} setLoginPass={setLoginPass} loginErr={loginErr} handleLogin={handleLogin} adminAuth={adminAuth} handleLogout={handleLogout} />}
        {page === "admin" && adminAuth && <PageAdmin structure={structure} equipe={equipe} documents={documents} actualites={actualites} api={api} showToast={showToast} reload={loadAll} reloadEquipe={async () => { const e = await api.get("/api/equipe"); setEquipe(e); }} reloadDocuments={async () => { const d = await api.get("/api/documents"); setDocuments(d); }} reloadActualites={async () => { const a = await api.get("/api/actualites"); setActualites(a); }} setStructure={setStructure} />}
      </main>

      {structure && <Footer structure={structure} nav={nav} />}
    </div>
  );
}

/* ===================== PAGE ACCUEIL ===================== */
function PageAccueil({ structure, actuPubliees, nav, setActu }) {
  return (
    <div>
      <section style={{ background: "linear-gradient(135deg, #FFF0E6 0%, #F2E8DC 50%, #E8F0E9 100%)", padding: "80px 20px 60px", textAlign: "center", position: "relative", overflow: "hidden" }}>
        <div style={{ maxWidth: 700, margin: "0 auto", position: "relative" }}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}><Logo url={structure?.logo} size={96} /></div>
          <h1 style={{ fontSize: 52, lineHeight: 1.1, color: "var(--warm)", marginBottom: 16 }}>
            Bienvenue au<br /><span style={{ color: "var(--terracotta)" }}>{structure?.nom}</span>
          </h1>
          <p style={{ fontSize: 18, color: "var(--muted)", lineHeight: 1.7, marginBottom: 32, fontWeight: 300 }}>{structure?.description?.substring(0, 180)}…</p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={() => nav("presentation")} style={{ background: "var(--terracotta)", color: "#fff", border: "none", padding: "13px 28px", borderRadius: 30, fontSize: 15, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>Découvrir la structure</button>
            <button onClick={() => nav("documents")} style={{ background: "none", color: "var(--terracotta)", border: "2px solid var(--terracotta)", padding: "12px 28px", borderRadius: 30, fontSize: 15, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>Nos documents</button>
          </div>
        </div>
      </section>

      <section style={{ maxWidth: 900, margin: "0 auto", padding: "50px 20px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 16 }}>
          {[["🏠", (structure?.places || "–")+" places", "d'accueil"], ["👶", "18 mois à 5 ans", "enfants accueillis"], ["🕐", "7h30 – 18h30", "lun. mar. jeu. ven."], ["🕐", "8h00 – 17h30", "le mercredi"]].map(([ic, val, lab], i) => (
            <div key={i} style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: "24px 16px", textAlign: "center" }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>{ic}</div>
              <div style={{ fontFamily: "'Fraunces', serif", fontSize: 22, color: "var(--terracotta)", marginBottom: 4 }}>{val}</div>
              <div style={{ fontSize: 13, color: "var(--muted)" }}>{lab}</div>
            </div>
          ))}
        </div>
      </section>

      {actuPubliees.length > 0 && (
        <section style={{ background: "var(--sand)", padding: "50px 20px" }}>
          <div style={{ maxWidth: 1000, margin: "0 auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 28 }}>
              <h2 style={{ fontSize: 32, color: "var(--warm)" }}>Dernières nouvelles</h2>
              <button onClick={() => nav("actualites")} style={{ background: "none", border: "none", color: "var(--terracotta)", cursor: "pointer", fontSize: 14, fontFamily: "'DM Sans', sans-serif" }}>Tout voir →</button>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16 }}>
              {actuPubliees.slice(0, 3).map(a => {
                const images = a.images || (a.image ? [a.image] : []);
                return (
                  <div key={a.id} onClick={() => { setActu(a); nav("actualites"); }} style={{ background: "#fff", borderRadius: "var(--radius)", overflow: "hidden", borderTop: `4px solid ${a.couleur}`, cursor: "pointer" }}>
                    {images.length > 0
                      ? <img src={imgUrl(images[0])} alt="" style={{ width: "100%", height: 160, objectFit: "cover" }} />
                      : <div style={{ padding: "20px", textAlign: "center", fontSize: 36 }}>{a.photo}</div>
                    }
                    <div style={{ padding: 20 }}>
                      <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 8 }}>{new Date(a.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}</div>
                      <h3 style={{ fontSize: 17, color: "var(--warm)", marginBottom: 8, lineHeight: 1.3 }}>{a.titre}</h3>
                      <p style={{ fontSize: 14, color: "var(--muted)", lineHeight: 1.6 }}>{a.extrait}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      <section style={{ maxWidth: 900, margin: "0 auto", padding: "60px 20px", textAlign: "center" }}>
        <h2 style={{ fontSize: 34, color: "var(--warm)", marginBottom: 12 }}>Nos valeurs</h2>
        <p style={{ color: "var(--muted)", marginBottom: 40, fontSize: 16 }}>Ce qui guide notre action au quotidien</p>
        <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
          {(structure?.valeurs || []).map((v, i) => (
            <div key={i} style={{ background: ["var(--terracotta)", "var(--sage)", "var(--sky)", "#9B6B9E"][i % 4], color: "#fff", borderRadius: 30, padding: "12px 24px", fontSize: 15, fontWeight: 500 }}>{v}</div>
          ))}
        </div>
      </section>
    </div>
  );
}

/* ===================== FACEBOOK WIDGET ===================== */
function FacebookWidget() {
  return (
    <a href="https://www.facebook.com/profile.php?id=61572760320760" target="_blank" rel="noopener noreferrer"
      style={{ display: "flex", alignItems: "center", gap: 20, background: "#1877F2", borderRadius: "var(--radius)", padding: "24px 28px", textDecoration: "none", color: "#fff", width: "100%" }}
      onMouseEnter={e => e.currentTarget.style.opacity = "0.9"}
      onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="white" style={{ flexShrink: 0 }}>
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
      <div>
        <div style={{ fontFamily: "'Fraunces', serif", fontSize: 20, fontWeight: 300, marginBottom: 6 }}>Association Jardin d'enfants Ô comme 3 Pommes</div>
        <div style={{ fontSize: 14, opacity: 0.9 }}>Suivez nos actualités, photos et événements sur Facebook</div>
        <div style={{ marginTop: 10, background: "rgba(255,255,255,0.2)", display: "inline-block", padding: "6px 16px", borderRadius: 20, fontSize: 13, fontWeight: 500 }}>Voir la page →</div>
      </div>
    </a>
  );
}

/* ===================== PAGE PRESENTATION ===================== */
function PagePresentation({ structure }) {
  if (!structure) return null;
  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: "60px 20px" }}>
      <span style={{ background: "var(--sage-light)", color: "var(--sage)", borderRadius: 20, padding: "4px 14px", fontSize: 13, fontWeight: 500 }}>{structure.type}</span>
      <h1 style={{ fontSize: 44, color: "var(--warm)", marginTop: 12, marginBottom: 16 }}>{structure.nom}</h1>
      <p style={{ fontSize: 17, color: "var(--muted)", lineHeight: 1.8, marginBottom: 40 }}>{structure.description}</p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 24, marginBottom: 40 }}>
        <div style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: 28 }}>
          <h3 style={{ fontSize: 20, color: "var(--terracotta)", marginBottom: 16 }}>📍 Nous trouver</h3>
          {[["Adresse", structure.adresse], ["Téléphone", structure.tel], ["Email", structure.email], ["Horaires", structure.horaires]].map(([k, v]) => (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid var(--border)", fontSize: 14 }}>
              <span style={{ color: "var(--muted)" }}>{k}</span>
              <span style={{ color: "var(--warm)", fontWeight: 500, textAlign: "right", maxWidth: "60%" }}>{v}</span>
            </div>
          ))}
        </div>
        <div style={{ background: "var(--sand)", borderRadius: "var(--radius)", padding: 28 }}>
          <h3 style={{ fontSize: 20, color: "var(--warm)", marginBottom: 16 }}>🌱 Nos valeurs</h3>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {(structure.valeurs || []).map((v, i) => (
              <span key={i} style={{ background: "#fff", border: "1px solid var(--border)", borderRadius: 20, padding: "6px 14px", fontSize: 13, color: "var(--warm)" }}>✦ {v}</span>
            ))}
          </div>
        </div>
      </div>
      <div style={{ marginBottom: 40 }}>
        <h3 style={{ fontSize: 22, color: "var(--warm)", marginBottom: 16 }}>📘 Notre page Facebook</h3>
        <div style={{ borderRadius: "var(--radius)", overflow: "hidden", border: "1px solid var(--border)", background: "#fff", padding: 16, display: "flex", justifyContent: "center" }}>
          <FacebookWidget />
        </div>
      </div>

      <div style={{ background: "linear-gradient(135deg, var(--terracotta), var(--terra-light))", borderRadius: "var(--radius)", padding: 32, color: "#fff" }}>
        <h3 style={{ fontSize: 22, marginBottom: 12, fontFamily: "'Fraunces', serif", fontWeight: 300 }}>Vous souhaitez nous rejoindre ?</h3>
        <p style={{ opacity: 0.9, marginBottom: 20, fontSize: 15 }}>Contactez-nous pour visiter la structure et déposer un dossier d'inscription.</p>
        <a href={`tel:${structure.tel}`} style={{ background: "#fff", color: "var(--terracotta)", padding: "10px 22px", borderRadius: 24, textDecoration: "none", fontSize: 14, fontWeight: 500 }}>📞 Appeler</a>
      </div>
    </div>
  );
}

/* ===================== PAGE EQUIPE ===================== */
function PageEquipe({ equipe }) {
  return (
    <div style={{ maxWidth: 1000, margin: "0 auto", padding: "60px 20px" }}>
      <div style={{ textAlign: "center", marginBottom: 50 }}>
        <h1 style={{ fontSize: 44, color: "var(--warm)", marginBottom: 12 }}>Notre équipe</h1>
        <p style={{ fontSize: 17, color: "var(--muted)", maxWidth: 500, margin: "0 auto" }}>Des professionnelles passionnées au service des tout-petits</p>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 20 }}>
        {equipe.map(m => (
          <div key={m.id} style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: 28, display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", transition: "transform .2s" }}
            onMouseEnter={e => e.currentTarget.style.transform = "translateY(-4px)"}
            onMouseLeave={e => e.currentTarget.style.transform = "none"}>
            {m.photo
              ? <img src={imgUrl(m.photo)} alt={m.prenom} style={{ width: 90, height: 90, borderRadius: "50%", objectFit: "cover", marginBottom: 16, border: `3px solid ${m.couleur}` }} />
              : <div style={{ width: 90, height: 90, borderRadius: "50%", background: m.couleur, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 28, fontWeight: 600, marginBottom: 16 }}>{m.initiales}</div>
            }
            <h3 style={{ fontSize: 18, color: "var(--warm)", marginBottom: 4 }}>{m.prenom} {m.nom}</h3>
            <span style={{ background: "var(--sage-light)", color: "var(--sage)", borderRadius: 20, padding: "3px 12px", fontSize: 12, fontWeight: 500, marginBottom: 14 }}>{m.poste}</span>
            <p style={{ fontSize: 14, color: "var(--muted)", lineHeight: 1.7 }}>{m.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ===================== PAGE DOCUMENTS ===================== */
function PageDocuments({ documents }) {
  const categories = [...new Set(documents.map(d => d.categorie?.trim()).filter(Boolean))];
  const [filtre, setFiltre] = useState("Tous");
  const docs = filtre === "Tous" ? documents : documents.filter(d => d.categorie?.trim().toLowerCase() === filtre.toLowerCase());

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: "60px 20px" }}>
      <h1 style={{ fontSize: 44, color: "var(--warm)", marginBottom: 8 }}>Documents</h1>
      <p style={{ color: "var(--muted)", marginBottom: 32, fontSize: 16 }}>Téléchargez nos documents utiles pour les familles</p>
      <div style={{ display: "flex", gap: 8, marginBottom: 28, flexWrap: "wrap" }}>
        {["Tous", ...categories].map(c => (
          <button key={c} onClick={() => setFiltre(c)} style={{ background: filtre===c ? "var(--terracotta)" : "var(--sand)", color: filtre===c ? "#fff" : "var(--warm)", border: "none", padding: "7px 16px", borderRadius: 20, fontSize: 13, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{c}</button>
        ))}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {docs.map(doc => (
          <div key={doc.id} style={{ background: "#fff", borderRadius: "var(--radius-sm)", border: "1px solid var(--border)", padding: "18px 22px", display: "flex", alignItems: "center", gap: 16, borderLeft: `4px solid ${doc.couleur}` }}>
            <div style={{ width: 44, height: 44, borderRadius: 8, background: doc.couleur + "18", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>📄</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 500, color: "var(--warm)", fontSize: 15, marginBottom: 2 }}>{doc.titre}</div>
              <div style={{ fontSize: 13, color: "var(--muted)" }}>{doc.categorie} · {doc.taille} · {doc.date}</div>
            </div>
            {doc.fichier
              ? <a href={`${API}${doc.fichier}`} download style={{ background: doc.couleur, color: "#fff", border: "none", padding: "8px 16px", borderRadius: 20, fontSize: 13, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 500, textDecoration: "none" }}>⬇ Télécharger</a>
              : <span style={{ fontSize: 12, color: "var(--muted)" }}>Bientôt disponible</span>
            }
          </div>
        ))}
      </div>
    </div>
  );
}

/* ===================== PAGE ACTUALITES ===================== */
function Lightbox({ images, startIdx, onClose }) {
  const [idx, setIdx] = useState(startIdx);
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "ArrowRight") setIdx(i => Math.min(i + 1, images.length - 1));
      if (e.key === "ArrowLeft") setIdx(i => Math.max(i - 1, 0));
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [images, onClose]);

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.92)", zIndex: 9999, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
      <button onClick={onClose} style={{ position: "absolute", top: 20, right: 24, background: "none", border: "none", color: "#fff", fontSize: 32, cursor: "pointer", lineHeight: 1 }}>✕</button>
      <div onClick={e => e.stopPropagation()} style={{ display: "flex", alignItems: "center", gap: 16, maxWidth: "90vw" }}>
        <button onClick={() => setIdx(i => Math.max(i - 1, 0))} disabled={idx === 0}
          style={{ background: "rgba(255,255,255,0.15)", border: "none", color: "#fff", fontSize: 28, width: 48, height: 48, borderRadius: "50%", cursor: idx === 0 ? "default" : "pointer", opacity: idx === 0 ? 0.3 : 1 }}>‹</button>
        <img src={imgUrl(images[idx])} alt="" style={{ maxHeight: "80vh", maxWidth: "75vw", objectFit: "contain", borderRadius: 8 }} />
        <button onClick={() => setIdx(i => Math.min(i + 1, images.length - 1))} disabled={idx === images.length - 1}
          style={{ background: "rgba(255,255,255,0.15)", border: "none", color: "#fff", fontSize: 28, width: 48, height: 48, borderRadius: "50%", cursor: idx === images.length - 1 ? "default" : "pointer", opacity: idx === images.length - 1 ? 0.3 : 1 }}>›</button>
      </div>
      <div style={{ display: "flex", gap: 8, marginTop: 16, overflowX: "auto", maxWidth: "90vw", padding: "0 8px" }}>
        {images.map((img, i) => (
          <img key={i} src={imgUrl(img)} alt="" onClick={e => { e.stopPropagation(); setIdx(i); }}
            style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 6, cursor: "pointer", flexShrink: 0, border: i === idx ? "3px solid var(--terracotta)" : "3px solid transparent", opacity: i === idx ? 1 : 0.6 }} />
        ))}
      </div>
      <div style={{ color: "rgba(255,255,255,0.5)", fontSize: 13, marginTop: 10 }}>{idx + 1} / {images.length}</div>
    </div>
  );
}

function GrillePhotos({ images, couleur, nbPhotos }) {
  const [lightbox, setLightbox] = useState(null);
  const shown = images.slice(0, nbPhotos);
  const reste = images.length - shown.length;

  if (shown.length === 0) return null;

  const layouts = {
    1: [{ gridColumn: "1 / -1", gridRow: "1" }],
    2: [{ gridColumn: "1", gridRow: "1" }, { gridColumn: "2", gridRow: "1" }],
    3: [{ gridColumn: "1 / -1", gridRow: "1" }, { gridColumn: "1", gridRow: "2" }, { gridColumn: "2", gridRow: "2" }],
  };
  const cells = layouts[Math.min(nbPhotos, 3)] || layouts[1];

  return (
    <>
      {lightbox !== null && <Lightbox images={images} startIdx={lightbox} onClose={() => setLightbox(null)} />}
      <div style={{ display: "grid", gridTemplateColumns: nbPhotos === 1 ? "1fr" : "1fr 1fr", gridTemplateRows: nbPhotos === 1 ? "220px" : "150px 150px", gap: 3, borderBottom: `3px solid ${couleur}` }}>
        {shown.map((img, i) => (
          <div key={i} onClick={() => setLightbox(i)} style={{ ...cells[i], position: "relative", overflow: "hidden", cursor: "pointer" }}>
            <img src={imgUrl(img)} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
            {i === shown.length - 1 && reste > 0 && (
              <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 22, fontWeight: 600 }}>
                +{reste}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}

function PageActualites({ actuPubliees, actu, setActu }) {
  const [lightbox, setLightbox] = useState(null);
  const images = actu ? (actu.images || (actu.image ? [actu.image] : [])) : [];

  if (actu) {
    return (
      <div style={{ maxWidth: 760, margin: "0 auto", padding: "40px 20px" }}>
        {lightbox !== null && <Lightbox images={images} startIdx={lightbox} onClose={() => setLightbox(null)} />}
        <button onClick={() => setActu(null)} style={{ background: "none", border: "none", color: "var(--terracotta)", cursor: "pointer", fontSize: 14, marginBottom: 24, fontFamily: "'DM Sans', sans-serif" }}>← Retour aux actualités</button>

        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <span style={{ background: actu.couleur + "22", color: actu.couleur, borderRadius: 20, padding: "4px 14px", fontSize: 13, fontWeight: 500 }}>{new Date(actu.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}</span>
        </div>
        <h1 style={{ fontSize: 36, color: "var(--warm)", marginBottom: 24, textAlign: "center", lineHeight: 1.2 }}>{actu.titre}</h1>

        {images.length === 0 && <div style={{ fontSize: 56, marginBottom: 24, textAlign: "center" }}>{actu.photo}</div>}

        {/* Album complet */}
        {images.length > 0 && (
          <div style={{ marginBottom: 24 }}>
            {/* Grande image principale */}
            <img src={imgUrl(images[0])} alt="" onClick={() => setLightbox(0)}
              style={{ width: "100%", maxHeight: 420, objectFit: "cover", borderRadius: "var(--radius)", cursor: "pointer", display: "block", marginBottom: 8 }} />
            {/* Grille miniatures */}
            {images.length > 1 && (
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))", gap: 6 }}>
                {images.slice(1).map((img, i) => (
                  <div key={i} onClick={() => setLightbox(i + 1)} style={{ position: "relative", cursor: "pointer", borderRadius: 8, overflow: "hidden", aspectRatio: "1" }}>
                    <img src={imgUrl(img)} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </div>
                ))}
              </div>
            )}
            {images.length > 1 && (
              <button onClick={() => setLightbox(0)} style={{ marginTop: 10, background: "none", border: "1px solid var(--border)", padding: "6px 16px", borderRadius: 20, fontSize: 13, cursor: "pointer", color: "var(--muted)", fontFamily: "'DM Sans', sans-serif" }}>
                🖼 Voir l'album ({images.length} photos)
              </button>
            )}
          </div>
        )}

        <div style={{ background: "#fff", borderRadius: "var(--radius)", padding: 32, fontSize: 16, color: "var(--muted)", lineHeight: 1.8 }}>{actu.contenu}</div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 1000, margin: "0 auto", padding: "60px 20px" }}>
      <h1 style={{ fontSize: 44, color: "var(--warm)", marginBottom: 12 }}>Actualités</h1>
      <p style={{ color: "var(--muted)", marginBottom: 40, fontSize: 16 }}>Les nouvelles de la structure, les événements et la vie des enfants</p>
      {actuPubliees.length === 0 && <div style={{ textAlign: "center", color: "var(--muted)", padding: 60 }}>Aucune actualité pour le moment.</div>}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 24 }}>
        {actuPubliees.map(a => {
          const imgs = a.images || (a.image ? [a.image] : []);
          const nb = a.nbPhotosAffichees || 1;
          return (
            <article key={a.id} onClick={() => setActu(a)} style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", overflow: "hidden", cursor: "pointer", transition: "transform .2s" }}
              onMouseEnter={e => e.currentTarget.style.transform = "translateY(-4px)"}
              onMouseLeave={e => e.currentTarget.style.transform = "none"}>
              {imgs.length > 0
                ? <GrillePhotos images={imgs} couleur={a.couleur} nbPhotos={nb} />
                : <div style={{ background: a.couleur + "18", padding: "28px 24px", textAlign: "center", fontSize: 52, borderBottom: `3px solid ${a.couleur}` }}>{a.photo}</div>
              }
              <div style={{ padding: "20px 22px" }}>
                <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 8 }}>{new Date(a.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}</div>
                <h3 style={{ fontSize: 17, color: "var(--warm)", marginBottom: 10, lineHeight: 1.3 }}>{a.titre}</h3>
                <p style={{ fontSize: 14, color: "var(--muted)", lineHeight: 1.6 }}>{a.extrait}</p>
                <div style={{ marginTop: 14, color: a.couleur, fontSize: 13, fontWeight: 500, display: "flex", alignItems: "center", gap: 6 }}>
                  {imgs.length > 0 && <span style={{ fontSize: 12, color: "var(--muted)" }}>📷 {imgs.length} photo{imgs.length > 1 ? "s" : ""} · </span>}
                  Lire la suite →
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}

/* ===================== PAGE LOGIN ===================== */
function PageLogin({ loginPass, setLoginPass, loginErr, handleLogin, adminAuth, handleLogout }) {
  return (
    <div style={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: "40px 36px", width: "100%", maxWidth: 380, textAlign: "center" }}>
        <div style={{ fontSize: 42, marginBottom: 16 }}>🔐</div>
        <h2 style={{ fontSize: 26, color: "var(--warm)", marginBottom: 8 }}>Espace administrateur</h2>
        {adminAuth ? (
          <div>
            <p style={{ color: "var(--sage)", marginBottom: 24, fontSize: 15 }}>✓ Connectée</p>
            <button onClick={handleLogout} style={{ background: "var(--terracotta)", color: "#fff", border: "none", padding: "11px 28px", borderRadius: 24, fontSize: 15, cursor: "pointer" }}>Se déconnecter</button>
          </div>
        ) : (
          <div>
            <input type="password" value={loginPass} onChange={e => setLoginPass(e.target.value)} onKeyDown={e => e.key === "Enter" && handleLogin()} placeholder="Mot de passe" style={{ width: "100%", border: `1px solid ${loginErr ? "#e74c3c" : "var(--border)"}`, borderRadius: 10, padding: "11px 14px", fontSize: 15, fontFamily: "'DM Sans', sans-serif", outline: "none", marginBottom: 8, color: "var(--warm)", background: "var(--cream)" }} />
            {loginErr && <p style={{ color: "#e74c3c", fontSize: 13, marginBottom: 8 }}>Mot de passe incorrect</p>}
            <button onClick={handleLogin} style={{ width: "100%", background: "var(--terracotta)", color: "#fff", border: "none", padding: "12px", borderRadius: 24, fontSize: 15, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 500, marginTop: 8 }}>Se connecter</button>
          </div>
        )}
      </div>
    </div>
  );
}

/* ===================== COMPOSANTS ADMIN ===================== */
function Inp({ label, val, onChange, multi, type = "text" }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 5 }}>{label}</label>
      {multi
        ? <textarea value={val} onChange={e => onChange(e.target.value)} rows={3} style={{ width: "100%", border: "1px solid var(--border)", borderRadius: 8, padding: "9px 12px", fontSize: 14, fontFamily: "'DM Sans', sans-serif", resize: "vertical", color: "var(--warm)", background: "var(--cream)" }} />
        : <input type={type} value={val} onChange={e => onChange(e.target.value)} style={{ width: "100%", border: "1px solid var(--border)", borderRadius: 8, padding: "9px 12px", fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: "var(--warm)", background: "var(--cream)" }} />
      }
    </div>
  );
}

const COLORS = ["#C9622A","#6B8F71","#7BAAC5","#9B6B9E","#D4A853","#E8855A"];
const EMOJIS = ["📰","🌱","🎨","🎉","📚","🏡","🍓","🎭","🌸","🌈","🎵","🧩","🌊","⭐"];

function ActuForm({ init, api, reload, showToast, onSave, onCancel }) {
  const [form, setForm] = useState(init || { titre: "", extrait: "", contenu: "", date: new Date().toISOString().split("T")[0], photo: "📰", couleur: "#C9622A", publie: true, nbPhotosAffichees: 1 });
  const [newFiles, setNewFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [keepImages, setKeepImages] = useState(init?.images || (init?.image ? [init.image] : []));
  const [saving, setSaving] = useState(false);

  const handleFiles = (e) => {
    const files = Array.from(e.target.files);
    setNewFiles(prev => [...prev, ...files]);
    setPreviews(prev => [...prev, ...files.map(f => ({ url: URL.createObjectURL(f) }))]);
  };

  const submit = async () => {
    if (!form.titre) return;
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("titre", form.titre);
      fd.append("extrait", form.extrait || "");
      fd.append("contenu", form.contenu || "");
      fd.append("date", form.date);
      fd.append("photo", form.photo || "📰");
      fd.append("couleur", form.couleur || "#C9622A");
      fd.append("publie", form.publie ? "true" : "false");
      fd.append("nbPhotosAffichees", String(form.nbPhotosAffichees || 1));
      fd.append("keepImages", JSON.stringify(keepImages));
      newFiles.forEach(f => fd.append("images", f));
      if (init?.id) await api.put(`/api/actualites/${init.id}`, fd, true);
      else await api.post("/api/actualites", fd, true);
      await reload();
      showToast(init?.id ? "Article mis à jour !" : "Article ajouté !");
      if (!init?.id) {
        setForm({ titre: "", extrait: "", contenu: "", date: new Date().toISOString().split("T")[0], photo: "📰", couleur: "#C9622A", publie: true, nbPhotosAffichees: 1 });
        setNewFiles([]);
        setPreviews([]);
        setKeepImages([]);
      }
      onSave?.();
    } catch(e) {
      showToast("Erreur lors de l'enregistrement");
      console.error(e);
    }
    setSaving(false);
  };

  const allPreviews = [
    ...keepImages.map(u => ({ url: imgUrl(u), keep: true, original: u })),
    ...previews.map((p, i) => ({ url: p.url, keep: false, idx: i }))
  ];

  return (
    <div style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: 24 }}>
      <h3 style={{ fontSize: 18, color: "var(--warm)", marginBottom: 20 }}>{init?.id ? "✏ Modifier l'article" : "+ Nouvel article"}</h3>
      <Inp label="Titre *" val={form.titre} onChange={v => setForm({ ...form, titre: v })} />
      <Inp label="Extrait" val={form.extrait} onChange={v => setForm({ ...form, extrait: v })} multi />
      <Inp label="Contenu complet" val={form.contenu} onChange={v => setForm({ ...form, contenu: v })} multi />
      <Inp label="Date" val={form.date} onChange={v => setForm({ ...form, date: v })} type="date" />
      <div style={{ marginBottom: 14 }}>
        <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Photos <span style={{ opacity: 0.6 }}>(jusqu'à 10)</span></label>
        <input type="file" accept="image/*" multiple onChange={handleFiles} style={{ fontSize: 13 }} />
        {allPreviews.length > 0 && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginTop: 10 }}>
            {allPreviews.map((p, i) => (
              <div key={i} style={{ position: "relative" }}>
                <img src={p.url} alt="" style={{ width: "100%", height: 80, objectFit: "cover", borderRadius: 6 }} />
                <button onClick={() => p.keep ? setKeepImages(prev => prev.filter(u => u !== p.original)) : (setNewFiles(prev => prev.filter((_, idx) => idx !== p.idx)), setPreviews(prev => prev.filter((_, idx) => idx !== p.idx)))}
                  style={{ position: "absolute", top: 4, right: 4, background: "rgba(0,0,0,0.6)", color: "#fff", border: "none", borderRadius: "50%", width: 22, height: 22, cursor: "pointer", fontSize: 12 }}>✕</button>
                {i === 0 && <span style={{ position: "absolute", bottom: 4, left: 4, background: "var(--terracotta)", color: "#fff", fontSize: 10, padding: "2px 6px", borderRadius: 4 }}>Couverture</span>}
              </div>
            ))}
          </div>
        )}
      </div>
      <div style={{ marginBottom: 14 }}>
        <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Photos affichées sur la carte</label>
        <div style={{ display: "flex", gap: 8 }}>
          {[1, 2, 3].map(n => (
            <button key={n} type="button" onClick={() => setForm({ ...form, nbPhotosAffichees: n })}
              style={{ flex: 1, padding: "8px", borderRadius: 8, border: form.nbPhotosAffichees === n ? "2px solid var(--terracotta)" : "1px solid var(--border)", background: form.nbPhotosAffichees === n ? "var(--sand)" : "#fff", cursor: "pointer", fontSize: 13, fontFamily: "'DM Sans', sans-serif", fontWeight: form.nbPhotosAffichees === n ? 600 : 400, color: form.nbPhotosAffichees === n ? "var(--terracotta)" : "var(--muted)" }}>
              {n} photo{n > 1 ? "s" : ""}
            </button>
          ))}
        </div>
        <p style={{ fontSize: 11, color: "var(--muted)", marginTop: 5 }}>Nombre de photos visibles sur la carte (l'album complet s'ouvre au clic)</p>
      </div>

      <div style={{ marginBottom: 14 }}>
        <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Emoji</label>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {EMOJIS.map(e => <button key={e} onClick={() => setForm({ ...form, photo: e })} style={{ fontSize: 20, background: form.photo === e ? "var(--sand)" : "none", border: form.photo === e ? "2px solid var(--terracotta)" : "2px solid transparent", borderRadius: 8, padding: 4, cursor: "pointer" }}>{e}</button>)}
        </div>
      </div>
      <div style={{ marginBottom: 14 }}>
        <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Couleur</label>
        <div style={{ display: "flex", gap: 8 }}>
          {COLORS.map(c => <button key={c} onClick={() => setForm({ ...form, couleur: c })} style={{ width: 28, height: 28, borderRadius: "50%", background: c, border: form.couleur === c ? "3px solid var(--warm)" : "3px solid transparent", cursor: "pointer" }} />)}
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 20 }}>
        <input type="checkbox" checked={form.publie} onChange={e => setForm({ ...form, publie: e.target.checked })} id="pub" />
        <label htmlFor="pub" style={{ fontSize: 14, color: "var(--muted)" }}>Publier immédiatement</label>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <button onClick={submit} disabled={saving} style={{ flex: 1, background: "var(--terracotta)", color: "#fff", border: "none", padding: "11px", borderRadius: 10, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{saving ? "Enregistrement…" : "✓ Enregistrer"}</button>
        {onCancel && <button onClick={onCancel} style={{ background: "var(--sand)", color: "var(--warm)", border: "none", padding: "11px 16px", borderRadius: 10, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>Annuler</button>}
      </div>
    </div>
  );
}

function DocForm({ init, api, reload, showToast, onSave, onCancel }) {
  const [form, setForm] = useState(init || { titre: "", categorie: "", taille: "", couleur: "#C9622A" });
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!form.titre) return;
    setSaving(true);
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    fd.append("date", new Date().toLocaleDateString("fr-FR"));
    if (file) { fd.append("fichier", file); fd.set("taille", (file.size / 1024).toFixed(0) + " Ko"); }
    try {
      if (init?.id) await api.put(`/api/documents/${init.id}`, fd, true);
      else await api.post("/api/documents", fd, true);
      await reload();
      showToast(init?.id ? "Document mis à jour !" : "Document ajouté !");
      if (!init?.id) {
        setForm({ titre: "", categorie: "", taille: "", couleur: "#C9622A" });
        setFile(null);
      }
      onSave?.();
    } catch(e) {
      showToast("Erreur lors de l'enregistrement");
    }
    setSaving(false);
  };

  return (
    <div style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: 24 }}>
      <h3 style={{ fontSize: 18, color: "var(--warm)", marginBottom: 20 }}>{init?.id ? "✏ Modifier" : "+ Nouveau document"}</h3>
      <Inp label="Titre *" val={form.titre} onChange={v => setForm({ ...form, titre: v })} />
      <Inp label="Catégorie" val={form.categorie} onChange={v => setForm({ ...form, categorie: v })} />
      <div style={{ marginBottom: 14 }}>
        <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Fichier PDF</label>
        <input type="file" accept=".pdf" onChange={e => setFile(e.target.files[0])} style={{ fontSize: 13 }} />
        {init?.fichier && !file && <p style={{ fontSize: 12, color: "var(--sage)", marginTop: 6 }}>✓ Fichier existant conservé</p>}
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Couleur</label>
        <div style={{ display: "flex", gap: 8 }}>
          {COLORS.map(c => <button key={c} onClick={() => setForm({ ...form, couleur: c })} style={{ width: 28, height: 28, borderRadius: "50%", background: c, border: form.couleur === c ? "3px solid var(--warm)" : "3px solid transparent", cursor: "pointer" }} />)}
        </div>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <button onClick={submit} disabled={saving} style={{ flex: 1, background: "var(--terracotta)", color: "#fff", border: "none", padding: "11px", borderRadius: 10, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{saving ? "Enregistrement…" : "✓ Enregistrer"}</button>
        {onCancel && <button onClick={onCancel} style={{ background: "var(--sand)", color: "var(--warm)", border: "none", padding: "11px 16px", borderRadius: 10, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>Annuler</button>}
      </div>
    </div>
  );
}

function MembreForm({ init, api, reload, reloadEquipe, showToast, onCancel, onSave }) {
  const [form, setForm] = useState(init || { prenom: "", nom: "", poste: "", desc: "", initiales: "", couleur: "#C9622A" });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(init?.photo ? imgUrl(init.photo) : null);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.prenom) return;
    setSaving(true);
    const fd = new FormData();
    fd.append("prenom", form.prenom || "");
    fd.append("nom", form.nom || "");
    fd.append("poste", form.poste || "");
    fd.append("desc", form.desc || "");
    fd.append("initiales", form.initiales || "");
    fd.append("couleur", form.couleur || "#C9622A");
    // N'ajouter photo que si nouveau fichier sélectionné
    if (file) {
      fd.append("photo", file, file.name);
    }
    try {
      if (init?.id) await api.put(`/api/equipe/${init.id}`, fd, true);
      else await api.post("/api/equipe", fd, true);
      await reloadEquipe();
      showToast("Enregistré !");
      if (!init?.id) {
        setForm({ prenom: "", nom: "", poste: "", desc: "", initiales: "", couleur: "#C9622A" });
        setFile(null);
        setPreview(null);
      }
      onSave?.();
    } catch(err) {
      showToast("Erreur lors de l'enregistrement");
    }
    setSaving(false);
  };

  return (
    <div style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: 24 }}>
      <h3 style={{ fontSize: 18, color: "var(--warm)", marginBottom: 20 }}>{init?.id ? "✏ Modifier le membre" : "+ Nouveau membre"}</h3>

      {/* Photo */}
      <div style={{ marginBottom: 20, display: "flex", alignItems: "center", gap: 16 }}>
        {preview
          ? <img src={preview} alt="" style={{ width: 72, height: 72, borderRadius: "50%", objectFit: "cover", border: `3px solid ${form.couleur}`, flexShrink: 0 }} />
          : <div style={{ width: 72, height: 72, borderRadius: "50%", background: form.couleur, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 24, fontWeight: 600, flexShrink: 0 }}>{form.initiales || "?"}</div>
        }
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Photo du membre</label>
          <input type="file" accept="image/*" onChange={e => { const f = e.target.files[0]; if (f) { setFile(f); setPreview(URL.createObjectURL(f)); } }} style={{ fontSize: 13 }} />
          {init?.photo && !file && <p style={{ fontSize: 12, color: "var(--sage)", marginTop: 4 }}>✓ Photo existante conservée</p>}
          {file && <p style={{ fontSize: 12, color: "var(--terracotta)", marginTop: 4 }}>📷 Nouvelle photo sélectionnée</p>}
        </div>
      </div>

      <Inp label="Prénom *" val={form.prenom} onChange={v => setForm({ ...form, prenom: v })} />
      <Inp label="Nom" val={form.nom} onChange={v => setForm({ ...form, nom: v })} />
      <Inp label="Poste / Diplôme" val={form.poste} onChange={v => setForm({ ...form, poste: v })} />
      <Inp label="Initiales (ex. JP)" val={form.initiales} onChange={v => setForm({ ...form, initiales: v })} />
      <Inp label="Description" val={form.desc} onChange={v => setForm({ ...form, desc: v })} multi />
      <div style={{ marginBottom: 16 }}>
        <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Couleur (bordure si photo)</label>
        <div style={{ display: "flex", gap: 8 }}>
          {COLORS.map(c => <button key={c} type="button" onClick={() => setForm({ ...form, couleur: c })} style={{ width: 28, height: 28, borderRadius: "50%", background: c, border: form.couleur === c ? "3px solid var(--warm)" : "3px solid transparent", cursor: "pointer" }} />)}
        </div>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <button type="button" onClick={submit} disabled={saving} style={{ flex: 1, background: "var(--terracotta)", color: "#fff", border: "none", padding: "11px", borderRadius: 10, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{saving ? "Enregistrement…" : "✓ Enregistrer"}</button>
        {onCancel && <button type="button" onClick={onCancel} style={{ background: "var(--sand)", color: "var(--warm)", border: "none", padding: "11px 16px", borderRadius: 10, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>Annuler</button>}
      </div>
    </div>
  );
}

function LogoForm({ structure, api, showToast, setStructure }) {
  const [url, setUrl] = useState(structure?.logo || "");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(structure?.logo ? imgUrl(structure.logo) : null);
  const [saving, setSaving] = useState(false);

  const apply = async () => {
    setSaving(true);
    let logoUrl = url;
    if (file) {
      const fd = new FormData();
      fd.append("file", file);
      const res = await api.post("/api/upload", fd, true);
      logoUrl = res.url;
    }
    await api.put("/api/structure", { ...structure, logo: logoUrl });
    setStructure(s => ({ ...s, logo: logoUrl }));
    showToast("Logo mis à jour !");
    setSaving(false);
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 20, padding: 16, background: "var(--sand)", borderRadius: 12 }}>
        {preview ? <img src={preview} alt="" style={{ width: 64, height: 64, borderRadius: "50%", objectFit: "cover" }} /> : <Logo url="" size={64} />}
        <div style={{ fontSize: 13, color: "var(--muted)" }}>Aperçu en temps réel</div>
      </div>
      <div style={{ marginBottom: 14 }}>
        <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Uploader une image</label>
        <input type="file" accept="image/*" onChange={e => { const f = e.target.files[0]; setFile(f); setPreview(URL.createObjectURL(f)); setUrl(""); }} style={{ fontSize: 13 }} />
      </div>
      <div style={{ marginBottom: 20 }}>
        <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Ou coller une URL</label>
        <input type="text" value={url} onChange={e => { setUrl(e.target.value); setPreview(e.target.value); setFile(null); }} placeholder="https://…" style={{ width: "100%", border: "1px solid var(--border)", borderRadius: 8, padding: "9px 12px", fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: "var(--warm)", background: "var(--cream)" }} />
      </div>
      <button onClick={apply} disabled={saving} style={{ width: "100%", background: "var(--terracotta)", color: "#fff", border: "none", padding: "11px", borderRadius: 10, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{saving ? "Enregistrement…" : "✓ Appliquer"}</button>
    </>
  );
}

/* ===================== DRAG & DROP LIST ===================== */
function DraggableList({ items, onReorder, renderItem }) {
  const [localItems, setLocalItems] = useState(items);
  const [dragIdx, setDragIdx] = useState(null);
  const [overIdx, setOverIdx] = useState(null);
  const isDragging = useRef(false);
  const pendingItems = useRef(null);

  // Sync depuis parent seulement si pas en train de drag
  useEffect(() => {
    if (!isDragging.current) {
      setLocalItems(items);
    }
  }, [items]);

  const onDragStart = (i) => {
    isDragging.current = true;
    setDragIdx(i);
  };

  const onDragOver = (e, i) => {
    e.preventDefault();
    e.stopPropagation();
    setOverIdx(i);
  };

  const onDrop = (e, i) => {
    e.preventDefault();
    if (dragIdx === null || dragIdx === i) { setDragIdx(null); setOverIdx(null); return; }
    const next = [...localItems];
    const [moved] = next.splice(dragIdx, 1);
    next.splice(i, 0, moved);
    pendingItems.current = next;
    setLocalItems(next);
    setDragIdx(null);
    setOverIdx(null);
  };

  const onDragEnd = () => {
    isDragging.current = false;
    if (pendingItems.current) {
      onReorder(pendingItems.current);
      pendingItems.current = null;
    }
    setDragIdx(null);
    setOverIdx(null);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {localItems.map((item, i) => (
        <div key={item.id}
          draggable
          onDragStart={() => onDragStart(i)}
          onDragOver={e => onDragOver(e, i)}
          onDrop={e => onDrop(e, i)}
          onDragEnd={onDragEnd}
          style={{
            opacity: dragIdx === i ? 0.4 : 1,
            border: overIdx === i && dragIdx !== i ? "2px dashed var(--terracotta)" : "1px solid var(--border)",
            borderRadius: "var(--radius-sm)",
            background: "#fff",
            transition: "opacity .15s",
            cursor: "grab",
            userSelect: "none",
          }}>
          {renderItem(item, i)}
        </div>
      ))}
    </div>
  );
}

/* ===================== PAGE ADMIN ===================== */
function PageAdmin({ structure, equipe, documents, actualites, api, showToast, reload, reloadEquipe, reloadDocuments, reloadActualites, setStructure }) {
  const [tab, setTab] = useState("actualites");
  const [editActu, setEditActu] = useState(null);
  const [editMembre, setEditMembre] = useState(null);
  const [editDoc, setEditDoc] = useState(null);

  return (
    <div style={{ maxWidth: 1000, margin: "0 auto", padding: "40px 20px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 32 }}>
        <div style={{ background: "var(--terracotta)", color: "#fff", borderRadius: 10, padding: "8px 14px", fontSize: 20 }}>⚙</div>
        <h1 style={{ fontSize: 32, color: "var(--warm)" }}>Tableau de bord</h1>
      </div>

      <div style={{ display: "flex", gap: 4, marginBottom: 28, background: "var(--sand)", borderRadius: 14, padding: 4, width: "fit-content", flexWrap: "wrap" }}>
        {[["actualites","📰 Actualités"],["equipe","👥 Équipe"],["documents","📄 Documents"],["logo","🖼 Logo"],["preinscriptions","📋 Préinscriptions"]].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} style={{ background: tab===k ? "#fff" : "none", border: "none", padding: "9px 20px", borderRadius: 10, fontSize: 14, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: tab===k ? 500 : 400, color: tab===k ? "var(--terracotta)" : "var(--muted)", boxShadow: tab===k ? "0 1px 4px rgba(0,0,0,0.1)" : "none" }}>{l}</button>
        ))}
      </div>

      {tab === "actualites" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1.2fr", gap: 24, alignItems: "start" }}>
          {editActu
            ? <ActuForm key={editActu.id} init={editActu} api={api} reload={reloadActualites} showToast={showToast} onSave={() => setEditActu(null)} onCancel={() => setEditActu(null)} />
            : <ActuForm key="new-actu" api={api} reload={reloadActualites} showToast={showToast} onSave={() => {}} />
          }
          <div>
            <h3 style={{ fontSize: 16, color: "var(--muted)", marginBottom: 14 }}>Articles ({actualites.length})</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {actualites.map(a => (
                <div key={a.id} style={{ background: "#fff", borderRadius: "var(--radius-sm)", border: "1px solid var(--border)", padding: "14px 16px", display: "flex", alignItems: "center", gap: 12, borderLeft: `4px solid ${a.couleur}` }}>
                  {a.image ? <img src={imgUrl(a.image)} alt="" style={{ width: 40, height: 40, borderRadius: 6, objectFit: "cover", flexShrink: 0 }} /> : <span style={{ fontSize: 24, flexShrink: 0 }}>{a.photo}</span>}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 500, fontSize: 14, color: "var(--warm)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{a.titre}</div>
                    <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 2 }}>{new Date(a.date).toLocaleDateString("fr-FR")} · {a.publie ? <span style={{ color: "var(--sage)" }}>✓ Publié</span> : <span style={{ color: "var(--muted)" }}>Brouillon</span>}</div>
                  </div>
                  <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                    <button onClick={async () => { await api.patch(`/api/actualites/${a.id}/toggle`); reloadActualites(); }} style={{ background: "var(--sage-light)", border: "none", width: 30, height: 30, borderRadius: 6, cursor: "pointer", fontSize: 14 }}>{a.publie ? "👁" : "👁‍🗨"}</button>
                    <button onClick={() => setEditActu(a)} style={{ background: "var(--sky-light)", border: "none", width: 30, height: 30, borderRadius: 6, cursor: "pointer", fontSize: 14 }}>✏</button>
                    <button onClick={async () => { await api.del(`/api/actualites/${a.id}`); reloadActualites(); showToast("Supprimé"); }} style={{ background: "#fee", border: "none", width: 30, height: 30, borderRadius: 6, cursor: "pointer", fontSize: 14 }}>🗑</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {tab === "equipe" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1.2fr", gap: 24, alignItems: "start" }}>
          <MembreForm key={editMembre?.id || "new"} init={editMembre} api={api} reload={reload} reloadEquipe={reloadEquipe} showToast={showToast} onCancel={editMembre ? () => setEditMembre(null) : null} onSave={() => { if (editMembre) setEditMembre(null); }} />
          <div>
            <h3 style={{ fontSize: 16, color: "var(--muted)", marginBottom: 6 }}>Membres ({equipe.length})</h3>
            <p style={{ fontSize: 12, color: "var(--muted)", marginBottom: 12 }}>↕ Glissez pour réordonner</p>
            <DraggableList
              items={equipe}
              onReorder={async (newList) => {
                await api.put("/api/equipe/reorder", { ids: newList.map(m => m.id) });
                await reloadEquipe();
              }}
              renderItem={(m) => (
                <div style={{ padding: "14px 16px", display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{ color: "var(--muted)", fontSize: 16, cursor: "grab", flexShrink: 0 }}>⠿</div>
                  <div style={{ width: 40, height: 40, borderRadius: "50%", background: m.couleur, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 14, fontWeight: 600, flexShrink: 0, overflow: "hidden" }}>
                    {m.photo ? <img src={imgUrl(m.photo)} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : m.initiales}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 500, fontSize: 14, color: "var(--warm)" }}>{m.prenom} {m.nom}</div>
                    <div style={{ fontSize: 12, color: "var(--muted)" }}>{m.poste}</div>
                  </div>
                  <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                    <button onClick={() => setEditMembre(m)} style={{ background: "var(--sky-light)", border: "none", width: 30, height: 30, borderRadius: 6, cursor: "pointer", fontSize: 14 }}>✏</button>
                    <button onClick={async () => { await api.del(`/api/equipe/${m.id}`); reloadEquipe(); showToast("Supprimé"); }} style={{ background: "#fee", border: "none", width: 30, height: 30, borderRadius: 6, cursor: "pointer", fontSize: 14 }}>🗑</button>
                  </div>
                </div>
              )}
            />
          </div>
        </div>
      )}

      {tab === "documents" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1.2fr", gap: 24, alignItems: "start" }}>
          {editDoc
            ? <DocForm key={editDoc.id} init={editDoc} api={api} reload={reloadDocuments} showToast={showToast} onSave={() => setEditDoc(null)} onCancel={() => setEditDoc(null)} />
            : <DocForm key="new-doc" api={api} reload={reloadDocuments} showToast={showToast} onSave={() => {}} />
          }
          <div>
            <h3 style={{ fontSize: 16, color: "var(--muted)", marginBottom: 6 }}>Documents ({documents.length})</h3>
            <p style={{ fontSize: 12, color: "var(--muted)", marginBottom: 12 }}>↕ Glissez pour réordonner</p>
            <DraggableList
              items={documents}
              onReorder={async (newList) => {
                await api.put("/api/documents/reorder", { ids: newList.map(d => d.id) });
                await reloadDocuments();
              }}
              renderItem={(dc) => (
                <div style={{ padding: "14px 16px", display: "flex", alignItems: "center", gap: 12, borderLeft: `4px solid ${dc.couleur}`, borderRadius: "var(--radius-sm)" }}>
                  <div style={{ color: "var(--muted)", fontSize: 16, cursor: "grab", flexShrink: 0 }}>⠿</div>
                  <div style={{ fontSize: 22 }}>📄</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 500, fontSize: 14, color: "var(--warm)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{dc.titre}</div>
                    <div style={{ fontSize: 12, color: "var(--muted)" }}>{dc.categorie} · {dc.fichier ? <span style={{ color: "var(--sage)" }}>✓ Fichier</span> : "Pas de fichier"}</div>
                  </div>
                  <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                    <button onClick={() => setEditDoc(dc)} style={{ background: "var(--sky-light)", border: "none", width: 30, height: 30, borderRadius: 6, cursor: "pointer", fontSize: 14 }}>✏</button>
                    <button onClick={async () => { await api.del(`/api/documents/${dc.id}`); reloadDocuments(); showToast("Supprimé"); }} style={{ background: "#fee", border: "none", width: 30, height: 30, borderRadius: 6, cursor: "pointer", fontSize: 14 }}>🗑</button>
                  </div>
                </div>
              )}
            />
          </div>
        </div>
      )}

      {tab === "logo" && (
        <div style={{ maxWidth: 500 }}>
          <div style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: 28 }}>
            <h3 style={{ fontSize: 18, color: "var(--warm)", marginBottom: 20 }}>🖼 Logo</h3>
            <LogoForm structure={structure} api={api} showToast={showToast} setStructure={setStructure} />
          </div>
        </div>
      )}

      {tab === "preinscriptions" && (
        <PreinscriptionsAdmin api={api} showToast={showToast} />
      )}
    </div>
  );
}

/* ===================== PAGE PRÉINSCRIPTION ===================== */
function ChampPreinscription({ label, clé, req, form, setForm }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 5 }}>{label}{req && " *"}</label>
      <input value={form[clé]} onChange={e => setForm({ ...form, [clé]: e.target.value })}
        style={{ width: "100%", border: "1px solid var(--border)", borderRadius: 8, padding: "9px 12px", fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: "var(--warm)", background: "var(--cream)" }} />
    </div>
  );
}

function PagePreinscription({ api, showToast }) {
  const jours = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi"];
  const [form, setForm] = useState({
    parent1_prenom: "", parent1_nom: "", parent1_tel: "", parent1_email: "",
    parent1_adresse: "", parent1_profession: "", parent1_caf: "", parent1_organisme: "",
    parent2_prenom: "", parent2_nom: "", parent2_tel: "", parent2_email: "",
    parent2_profession: "", parent2_caf: "", parent2_organisme: "",
    enfant_prenom: "", enfant_nom: "", enfant_ddn: "", date_contrat: "",
    infos: "",
  });
  const [horaires, setHoraires] = useState(
    Object.fromEntries(jours.map(j => [j, { matin: false, apresmidi: false, journee: false }]))
  );
  const [sent, setSent] = useState(false);
  const [saving, setSaving] = useState(false);

  const toggleHoraire = (jour, periode) => {
    setHoraires(h => {
      const current = h[jour];
      if (periode === "journee") {
        const val = !current.journee;
        return { ...h, [jour]: { matin: val, apresmidi: val, journee: val } };
      }
      return { ...h, [jour]: { ...current, [periode]: !current[periode], journee: false } };
    });
  };

  const submit = async () => {
    if (!form.parent1_nom || !form.parent1_tel || !form.enfant_prenom) {
      showToast("Merci de remplir les champs obligatoires *");
      return;
    }
    setSaving(true);
    try {
      await api.post("/api/preinscriptions", { ...form, horaires: JSON.stringify(horaires) });
      setSent(true);
    } catch (e) {
      showToast("Erreur lors de l'envoi, veuillez réessayer.");
    }
    setSaving(false);
  };

  if (sent) return (
    <div style={{ maxWidth: 600, margin: "80px auto", padding: 20, textAlign: "center" }}>
      <div style={{ fontSize: 64, marginBottom: 20 }}>🍎</div>
      <h2 style={{ fontSize: 32, color: "var(--warm)", marginBottom: 12 }}>Demande envoyée !</h2>
      <p style={{ color: "var(--muted)", fontSize: 16, lineHeight: 1.7 }}>Votre dossier de préinscription a bien été reçu. Notre équipe vous contactera dans les meilleurs délais.</p>
    </div>
  );

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: "60px 20px" }}>
      <h1 style={{ fontSize: 44, color: "var(--warm)", marginBottom: 8 }}>Préinscription</h1>
      <p style={{ color: "var(--muted)", marginBottom: 40, fontSize: 16 }}>Remplissez ce formulaire pour déposer une demande d'inscription. Les champs * sont obligatoires.</p>

      {/* Enfant */}
      <div style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: 28, marginBottom: 20 }}>
        <h3 style={{ fontSize: 18, color: "var(--terracotta)", marginBottom: 20 }}>👶 L'enfant</h3>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <ChampPreinscription form={form} setForm={setForm} label="Prénom" clé="enfant_prenom" req />
          <ChampPreinscription form={form} setForm={setForm} label="Nom" clé="enfant_nom" req />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 5 }}>Date de naissance *</label>
            <input type="date" value={form.enfant_ddn} onChange={e => setForm({ ...form, enfant_ddn: e.target.value })}
              max={new Date().toISOString().split("T")[0]}
              style={{ width: "100%", border: "1px solid var(--border)", borderRadius: 8, padding: "9px 12px", fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: "var(--warm)", background: "var(--cream)", cursor: "pointer" }} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 5 }}>Date de début de contrat souhaitée</label>
            <input type="date" value={form.date_contrat} onChange={e => setForm({ ...form, date_contrat: e.target.value })}
              min={new Date().toISOString().split("T")[0]}
              style={{ width: "100%", border: "1px solid var(--border)", borderRadius: 8, padding: "9px 12px", fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: "var(--warm)", background: "var(--cream)", cursor: "pointer" }} />
          </div>
        </div>
      </div>

      {/* Parent 1 */}
      <div style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: 28, marginBottom: 20 }}>
        <h3 style={{ fontSize: 18, color: "var(--terracotta)", marginBottom: 20 }}>👤 Parent / Responsable légal 1</h3>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <ChampPreinscription form={form} setForm={setForm} label="Prénom" clé="parent1_prenom" />
          <ChampPreinscription form={form} setForm={setForm} label="Nom" clé="parent1_nom" req />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <ChampPreinscription form={form} setForm={setForm} label="Téléphone" clé="parent1_tel" req />
          <ChampPreinscription form={form} setForm={setForm} label="Email" clé="parent1_email" />
        </div>
        <ChampPreinscription form={form} setForm={setForm} label="Adresse" clé="parent1_adresse" />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <ChampPreinscription form={form} setForm={setForm} label="Profession" clé="parent1_profession" />
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Organisme & N° allocataire</label>
            <div style={{ display: "flex", gap: 12, marginBottom: 8 }}>
              {["CAF", "MSA"].map(org => (
                <label key={org} style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 14, color: "var(--warm)" }}>
                  <input type="radio" name="parent1_organisme" value={org} checked={form.parent1_organisme === org} onChange={e => setForm({ ...form, parent1_organisme: e.target.value })} style={{ accentColor: "var(--terracotta)", width: 16, height: 16 }} />
                  {org}
                </label>
              ))}
            </div>
            <input value={form.parent1_caf} onChange={e => setForm({ ...form, parent1_caf: e.target.value })}
              placeholder={form.parent1_organisme ? `N° ${form.parent1_organisme}` : "N° allocataire"}
              style={{ width: "100%", border: "1px solid var(--border)", borderRadius: 8, padding: "9px 12px", fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: "var(--warm)", background: "var(--cream)" }} />
          </div>
        </div>
      </div>

      {/* Parent 2 */}
      <div style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: 28, marginBottom: 20 }}>
        <h3 style={{ fontSize: 18, color: "var(--warm)", marginBottom: 20 }}>👤 Parent / Responsable légal 2 <span style={{ fontSize: 13, color: "var(--muted)", fontWeight: 400 }}>(optionnel)</span></h3>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <ChampPreinscription form={form} setForm={setForm} label="Prénom" clé="parent2_prenom" />
          <ChampPreinscription form={form} setForm={setForm} label="Nom" clé="parent2_nom" />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <ChampPreinscription form={form} setForm={setForm} label="Téléphone" clé="parent2_tel" />
          <ChampPreinscription form={form} setForm={setForm} label="Email" clé="parent2_email" />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <ChampPreinscription form={form} setForm={setForm} label="Profession" clé="parent2_profession" />
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 13, color: "var(--muted)", display: "block", marginBottom: 6 }}>Organisme & N° allocataire</label>
            <div style={{ display: "flex", gap: 12, marginBottom: 8 }}>
              {["CAF", "MSA"].map(org => (
                <label key={org} style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 14, color: "var(--warm)" }}>
                  <input type="radio" name="parent2_organisme" value={org} checked={form.parent2_organisme === org} onChange={e => setForm({ ...form, parent2_organisme: e.target.value })} style={{ accentColor: "var(--terracotta)", width: 16, height: 16 }} />
                  {org}
                </label>
              ))}
            </div>
            <input value={form.parent2_caf} onChange={e => setForm({ ...form, parent2_caf: e.target.value })}
              placeholder={form.parent2_organisme ? `N° ${form.parent2_organisme}` : "N° allocataire"}
              style={{ width: "100%", border: "1px solid var(--border)", borderRadius: 8, padding: "9px 12px", fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: "var(--warm)", background: "var(--cream)" }} />
          </div>
        </div>
      </div>

      {/* Horaires */}
      <div style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: 28, marginBottom: 20 }}>
        <h3 style={{ fontSize: 18, color: "var(--terracotta)", marginBottom: 8 }}>🕐 Horaires souhaités</h3>
        <p style={{ fontSize: 13, color: "var(--muted)", marginBottom: 8 }}>Cochez "Journée complète" pour sélectionner matin et après-midi en une fois.</p>
        <p style={{ fontSize: 12, color: "var(--muted)", marginBottom: 16 }}>* Le mercredi, fermeture à 17h30</p>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
            <thead>
              <tr>
                <th style={{ padding: "10px 14px", textAlign: "left", color: "var(--muted)", fontWeight: 500, borderBottom: "2px solid var(--border)" }}>Jour</th>
                <th style={{ padding: "10px 14px", textAlign: "center", color: "var(--muted)", fontWeight: 500, borderBottom: "2px solid var(--border)" }}>Matin<br /><span style={{ fontSize: 11, fontWeight: 400 }}>7h30 – 12h00</span></th>
                <th style={{ padding: "10px 14px", textAlign: "center", color: "var(--muted)", fontWeight: 500, borderBottom: "2px solid var(--border)" }}>Après-midi<br /><span style={{ fontSize: 11, fontWeight: 400 }}>12h00 – 18h30*</span></th>
                <th style={{ padding: "10px 14px", textAlign: "center", color: "var(--terracotta)", fontWeight: 500, borderBottom: "2px solid var(--border)" }}>Journée complète<br /><span style={{ fontSize: 11, fontWeight: 400 }}>7h30 – 18h30*</span></th>
              </tr>
            </thead>
            <tbody>
              {jours.map((jour, i) => (
                <tr key={jour} style={{ background: i % 2 === 0 ? "var(--cream)" : "#fff" }}>
                  <td style={{ padding: "12px 14px", color: "var(--warm)", fontWeight: 500 }}>{jour}</td>
                  <td style={{ padding: "12px 14px", textAlign: "center" }}>
                    <input type="checkbox" checked={horaires[jour].matin} onChange={() => toggleHoraire(jour, "matin")} style={{ width: 18, height: 18, cursor: "pointer", accentColor: "var(--terracotta)" }} />
                  </td>
                  <td style={{ padding: "12px 14px", textAlign: "center" }}>
                    <input type="checkbox" checked={horaires[jour].apresmidi} onChange={() => toggleHoraire(jour, "apresmidi")} style={{ width: 18, height: 18, cursor: "pointer", accentColor: "var(--terracotta)" }} />
                  </td>
                  <td style={{ padding: "12px 14px", textAlign: "center" }}>
                    <input type="checkbox" checked={horaires[jour].journee} onChange={() => toggleHoraire(jour, "journee")} style={{ width: 18, height: 18, cursor: "pointer", accentColor: "var(--terracotta)" }} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Infos */}
      <div style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: 28, marginBottom: 32 }}>
        <h3 style={{ fontSize: 18, color: "var(--warm)", marginBottom: 8 }}>📝 Informations complémentaires</h3>
        <p style={{ fontSize: 13, color: "var(--muted)", marginBottom: 14 }}>Allergies, besoins particuliers, situation familiale, remarques…</p>
        <textarea value={form.infos} onChange={e => setForm({ ...form, infos: e.target.value })} rows={5}
          style={{ width: "100%", border: "1px solid var(--border)", borderRadius: 8, padding: "10px 12px", fontSize: 14, fontFamily: "'DM Sans', sans-serif", resize: "vertical", color: "var(--warm)", background: "var(--cream)" }}
          placeholder="Décrivez ici toute information utile pour l'accueil de votre enfant…" />
      </div>

      <button onClick={submit} disabled={saving}
        style={{ width: "100%", background: "var(--terracotta)", color: "#fff", border: "none", padding: "16px", borderRadius: 14, fontSize: 16, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>
        {saving ? "Envoi en cours…" : "📩 Envoyer la demande de préinscription"}
      </button>
    </div>
  );
}

/* ===================== ADMIN PRÉINSCRIPTIONS ===================== */
function PreinscriptionsAdmin({ api, showToast }) {
  const jours = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi"];
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const data = await api.get("/api/preinscriptions");
    setList(Array.isArray(data) ? data : []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const setStatut = async (id, statut) => {
    await fetch(`/api/preinscriptions/${id}/statut`, {
      method: "PATCH",
      headers: { "x-admin-pass": ADMIN_PASS, "Content-Type": "application/json" },
      body: JSON.stringify({ statut })
    });
    await load();
    showToast("Statut mis à jour");
  };

  const del = async (id) => {
    await api.del(`/api/preinscriptions/${id}`);
    await load();
    setSelected(null);
    showToast("Dossier supprimé");
  };

  const statutColor = { "en attente": "#D4A853", "accepté": "#6B8F71", "refusé": "#C0392B" };
  const parseHoraires = (h) => { try { return typeof h === "string" ? JSON.parse(h) : h; } catch { return {}; } };

  if (loading) return <div style={{ color: "var(--muted)", padding: 40 }}>Chargement…</div>;

  if (selected) {
    const h = parseHoraires(selected.horaires);
    return (
      <div style={{ maxWidth: 700 }}>
        <button onClick={() => setSelected(null)} style={{ background: "none", border: "none", color: "var(--terracotta)", cursor: "pointer", fontSize: 14, marginBottom: 20, fontFamily: "'DM Sans', sans-serif" }}>← Retour à la liste</button>
        <div style={{ background: "#fff", borderRadius: "var(--radius)", border: "1px solid var(--border)", padding: 28 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
            <h3 style={{ fontSize: 20, color: "var(--warm)" }}>Dossier — {selected.enfant_prenom} {selected.enfant_nom}</h3>
            <span style={{ background: statutColor[selected.statut] + "22", color: statutColor[selected.statut], borderRadius: 20, padding: "4px 12px", fontSize: 13, fontWeight: 500 }}>{selected.statut}</span>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 20 }}>
            <div>
              <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 4 }}>👶 ENFANT</div>
              <div style={{ fontWeight: 500 }}>{selected.enfant_prenom} {selected.enfant_nom}</div>
              <div style={{ fontSize: 13, color: "var(--muted)" }}>Né(e) le {selected.enfant_ddn}</div>
              {selected.date_contrat && <div style={{ fontSize: 13, color: "var(--terracotta)", marginTop: 4 }}>📅 Début contrat souhaité : {selected.date_contrat}</div>}
            </div>
            <div>
              <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 4 }}>📅 DÉPÔT</div>
              <div style={{ fontSize: 13 }}>{selected.date}</div>
            </div>
          </div>

          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 8 }}>👤 PARENT 1</div>
            <div style={{ fontWeight: 500 }}>{selected.parent1_prenom} {selected.parent1_nom}</div>
            <div style={{ fontSize: 13, color: "var(--muted)" }}>📞 {selected.parent1_tel} · ✉ {selected.parent1_email}</div>
            {selected.parent1_adresse && <div style={{ fontSize: 13, color: "var(--muted)" }}>📍 {selected.parent1_adresse}</div>}
            {selected.parent1_profession && <div style={{ fontSize: 13, color: "var(--muted)" }}>💼 {selected.parent1_profession}</div>}
            {selected.parent1_caf && <div style={{ fontSize: 13, color: "var(--muted)" }}>🏦 {selected.parent1_organisme || "CAF"} : {selected.parent1_caf}</div>}
          </div>

          {selected.parent2_nom && (
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 8 }}>👤 PARENT 2</div>
              <div style={{ fontWeight: 500 }}>{selected.parent2_prenom} {selected.parent2_nom}</div>
              <div style={{ fontSize: 13, color: "var(--muted)" }}>📞 {selected.parent2_tel} · ✉ {selected.parent2_email}</div>
              {selected.parent2_profession && <div style={{ fontSize: 13, color: "var(--muted)" }}>💼 {selected.parent2_profession}</div>}
              {selected.parent2_caf && <div style={{ fontSize: 13, color: "var(--muted)" }}>🏦 {selected.parent2_organisme || "CAF"} : {selected.parent2_caf}</div>}
            </div>
          )}

          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 10 }}>🕐 HORAIRES SOUHAITÉS</div>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: "var(--sand)" }}>
                  <th style={{ padding: "8px 12px", textAlign: "left", fontWeight: 500 }}>Jour</th>
                  <th style={{ padding: "8px 12px", textAlign: "center", fontWeight: 500 }}>Matin</th>
                  <th style={{ padding: "8px 12px", textAlign: "center", fontWeight: 500 }}>Après-midi</th>
                  <th style={{ padding: "8px 12px", textAlign: "center", fontWeight: 500, color: "var(--terracotta)" }}>Journée</th>
                </tr>
              </thead>
              <tbody>
                {jours.map((j, i) => (
                  <tr key={j} style={{ background: i % 2 === 0 ? "#fff" : "var(--cream)" }}>
                    <td style={{ padding: "8px 12px", fontWeight: 500 }}>{j}</td>
                    <td style={{ padding: "8px 12px", textAlign: "center" }}>{h[j]?.matin ? "✅" : "—"}</td>
                    <td style={{ padding: "8px 12px", textAlign: "center" }}>{h[j]?.apresmidi ? "✅" : "—"}</td>
                    <td style={{ padding: "8px 12px", textAlign: "center" }}>{h[j]?.journee ? "✅" : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {selected.infos && (
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 8 }}>📝 INFORMATIONS COMPLÉMENTAIRES</div>
              <div style={{ background: "var(--sand)", borderRadius: 8, padding: "12px 14px", fontSize: 14, lineHeight: 1.7 }}>{selected.infos}</div>
            </div>
          )}

          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {["en attente", "accepté", "refusé"].map(s => (
              <button key={s} onClick={() => setStatut(selected.id, s)}
                style={{ background: selected.statut === s ? statutColor[s] : "var(--sand)", color: selected.statut === s ? "#fff" : "var(--warm)", border: "none", padding: "8px 16px", borderRadius: 20, fontSize: 13, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>
                {s}
              </button>
            ))}
            <button onClick={() => del(selected.id)} style={{ background: "#fee", color: "#c0392b", border: "none", padding: "8px 16px", borderRadius: 20, fontSize: 13, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", marginLeft: "auto" }}>
              🗑 Supprimer
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h3 style={{ fontSize: 16, color: "var(--muted)" }}>Dossiers reçus ({list.length})</h3>
        <button onClick={load} style={{ background: "var(--sand)", border: "none", padding: "6px 14px", borderRadius: 20, fontSize: 13, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>↻ Actualiser</button>
      </div>
      {list.length === 0 && <div style={{ textAlign: "center", color: "var(--muted)", padding: 60 }}>Aucune préinscription reçue.</div>}
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {list.slice().reverse().map(p => (
          <div key={p.id} onClick={() => setSelected(p)}
            style={{ background: "#fff", borderRadius: "var(--radius-sm)", border: "1px solid var(--border)", padding: "14px 18px", display: "flex", alignItems: "center", gap: 14, cursor: "pointer", borderLeft: `4px solid ${statutColor[p.statut] || "#ccc"}` }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 500, fontSize: 14, color: "var(--warm)" }}>{p.enfant_prenom} {p.enfant_nom}</div>
              <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 2 }}>Parent : {p.parent1_prenom} {p.parent1_nom} · {p.parent1_tel}</div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4, flexShrink: 0 }}>
              <span style={{ background: statutColor[p.statut] + "22", color: statutColor[p.statut], borderRadius: 20, padding: "2px 10px", fontSize: 12, fontWeight: 500 }}>{p.statut}</span>
              <span style={{ fontSize: 11, color: "var(--muted)" }}>{p.date}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ===================== FOOTER ===================== */
function Footer({ structure, nav }) {
  return (
    <footer style={{ background: "var(--warm)", color: "#FFF9F5", padding: "40px 20px", marginTop: 60 }}>
      <div style={{ maxWidth: 1000, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 32 }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <Logo url={structure.logo} size={32} />
            <span style={{ fontFamily: "'Fraunces', serif", fontSize: 20, fontWeight: 300 }}>{structure.nom}</span>
          </div>
          <p style={{ fontSize: 14, opacity: 0.6, lineHeight: 1.7 }}>{structure.type}<br />{structure.adresse}</p>
        </div>
        <div>
          <div style={{ fontWeight: 500, marginBottom: 12, fontSize: 14, opacity: 0.8 }}>Navigation</div>
          {[["presentation","La structure"],["equipe","L'équipe"],["documents","Documents"],["actualites","Actualités"],["preinscription","Préinscription"]].map(([k,l]) => (
            <div key={k}><button onClick={() => nav(k)} style={{ background: "none", border: "none", color: "#FFF9F5", opacity: 0.6, cursor: "pointer", fontSize: 14, padding: "3px 0", fontFamily: "'DM Sans', sans-serif" }}>{l}</button></div>
          ))}
        </div>
        <div>
          <div style={{ fontWeight: 500, marginBottom: 12, fontSize: 14, opacity: 0.8 }}>Contact</div>
          <div style={{ fontSize: 14, opacity: 0.6, lineHeight: 2 }}>
            <div>📞 {structure.tel}</div>
            <div>✉ {structure.email}</div>
            <div>🕐 {structure.horaires}</div>
          </div>
        </div>
      </div>
      <div style={{ maxWidth: 1000, margin: "28px auto 0", borderTop: "1px solid rgba(255,249,245,0.15)", paddingTop: 20, fontSize: 13, opacity: 0.4, textAlign: "center" }}>
        © 2024 {structure.nom} — Tous droits réservés
      </div>
    </footer>
  );
}